import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import {
    Chip,
} from '@material-ui/core';
import {
    Table, Whisper, Popover,
} from 'rsuite';
import './AuditReportNameCell.scss';
import { Icon as MdiIcon } from '@mdi/react';
import { mdiStarBox } from '@mdi/js';
import { ColoredDot } from '@commonClient2/components';
import { getProfileStatusLabel } from '../../../Enums/Helpers/LabellingHelper';
import { getProfileStatusColor } from '../../../Enums/Helpers/StylingHelper';

const { Cell } = Table;

/**
 * @param {{
 *  rowData: ManagerAppData.IAuditableBid,
 *  dataKey: string,
 *  iconTooltipLabel: string,
 * }} AuditReportNameCellProps
 */
const AuditReportNameCell = ({
    rowData, dataKey, iconTooltipLabel, ...props
}) => {
    const { t } = useTranslation('shiftBidding');
    const hasName = !!rowData.name;

    const tooltipStatus = (
        <Popover visible>
            {getProfileStatusLabel(rowData.status)}
        </Popover>
    );
    const tooltipName = (
        <Popover
            className="arnc-popover-name"
            visible
        >
            {rowData.name}
        </Popover>
    );
    const tooltipParentIcon = (
        <Popover visible>
            {iconTooltipLabel}
        </Popover>
    );

    return (
        <Cell
            {...props}
            style={{ cursor: 'default', display: 'flex', alignItems: 'center' }}
            dataKey={dataKey}
        >
            <Whisper
                placement="autoVerticalStart"
                delay={500}
                delayOpen={500}
                delayClose={500}
                speaker={tooltipStatus}
            >
                <span className="arnc-chipTagStatus">
                    <ColoredDot style={getProfileStatusColor(rowData.status, false)} />
                </span>
            </Whisper>
            {
                rowData.isReImportNeeded
                && (
                    <Whisper
                        delay={500}
                        delayOpen={500}
                        delayClose={500}
                        placement="right"
                        speaker={<Popover visible>The workplan selected has been updated</Popover>}
                    >
                        <FontAwesomeIcon
                            className="arnc-workplan-updated-icon"
                            icon={faExclamationTriangle}
                        />
                    </Whisper>
                )
            }
            {
                hasName
                    ? (
                        <Whisper
                            delay={500}
                            delayOpen={500}
                            delayClose={500}
                            placement="autoVerticalStart"
                            speaker={tooltipName}
                        >
                            <span className="arnc-name-cell-label">
                                {rowData.name}
                            </span>
                        </Whisper>
                    )
                    : <span className="arnc-name-cell-no-name arnc-name-cell-label" />
            }
            {
                // @ts-ignore
                !!rowData.rebidNumber
                && (
                    <Chip
                        label={t('common.rebidNumber', { number: rowData.rebidNumber })}
                        variant="outlined"
                        className="arnc-rebid-chip"
                    />
                )
            }
            {
                rowData.isOriginalBid
                && (
                    <Whisper
                        delay={500}
                        delayOpen={500}
                        delayClose={500}
                        placement="bottom"
                        speaker={tooltipParentIcon}
                    >
                        <MdiIcon
                            className="arnc-original-bid-icon"
                            path={mdiStarBox}
                            size={1}
                        />
                    </Whisper>
                )
            }
        </Cell>
    );
};

export default AuditReportNameCell;

